import {ISharedModalBasic} from '../../../shared/shared-models/modals/shared-modal-basic';
import {IconsEnum} from '../../../shared-modules/shared-icons/models/icons.enum';
import {IconColourEnum} from '../../../shared-modules/shared-icons/models/icons-colour.enum';

export const AUTO_ORDER_OPEN_ORDER_ADD_ITEMS: ISharedModalBasic = {
  buttonAccept: true,
  buttonAcceptText: 'Add Items',
  buttonClose: true,
  buttonCloseCross: false,
  buttonCloseText: `Cancel`,
  modalTitle: `Add Items To order`,
  modalTitleIcon: IconsEnum.infoSlabCircleOutline,
  modalTitleIconColor: IconColourEnum.yellow,
  contextHeading: `Warning: Added Stock Items Will Have no History.`,
  contextDescription: [
    'All added items will have no history and as such we will not be able to show you suggested quantities',
    'Are you sure you want to proceed?',
  ],
};

export const AUTO_ORDER_OPEN_ORDER_FLAG_ITEMS: ISharedModalBasic = {
  buttonAccept: true,
  buttonAcceptText: 'Tag Item',
  buttonCloseCross: false,
  buttonCloseText: 'Cancel',
  buttonClose: true,
  modalTitle: 'Add Tag to Stock Items',
  modalTitleIcon: IconsEnum.infoSlabCircleOutline,
  modalTitleIconColor: IconColourEnum.green,
  contextHeading: 'Tag Items for Supplier Changes',
  contextDescription: [
    'Would you like to tag these stock items to indicate a supplier change?',
    'Adding tags will make it easier to find these items on the Stock Manager page and update their suppliers accordingly.',
  ],
};
